module.exports = __webpack_public_path__ + "img/awe.13c7c93d.png";